import { useAjaxCall } from '~/_shared/utils/hooks/useAjaxCall';
import { cancelOptimizedTerritory } from '~/store/boundaries/boundaries.repository';

export const useCancelOptimizedTerritories = () => {
  const { invokeAjax, isLoading } = useAjaxCall((clientId: number, hash: string) =>
    cancelOptimizedTerritory(clientId, hash)
  );

  return {
    isLoading,
    cancelOptimizedTerritory: invokeAjax,
  };
};
